import {Component, Input} from '@angular/core';

@Component({
  selector: 'app-icon-context-document',
  templateUrl: './icon-context-document.component.html',
  styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconContextDocumentComponent {
    @Input() isActive: boolean = false;
}
